import React from 'react'
import { ProfileCompletedChallenges } from 'src/component/profile/profile-completed-challenges'
import { ProfileNotCompletedChallenges } from 'src/component/profile/profile-not-completed-challenges'
import { ProfileSeriesAwards } from 'src/component/profile/profile-series-awards'

export const ProfileAwardsScreen = (): React.ReactElement => {
  return (
    <div className="pb-10 md:pb-20">
      <ProfileSeriesAwards />
      <ProfileCompletedChallenges />
      <ProfileNotCompletedChallenges />
    </div>
  )
}
